import { Component } from "react-image-crop";
import CreateButton from "../../../components/UIComponent/Buttons/CreateButton";
import Table from "../../../components/table/Table";
import ActionEditButton from "../../../components/UIComponent/ActionTableComponent/ActionEditButton";
import ActionDeleteButton from "../../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import LeadershipPositionsServices from "../../../services/axiosServices/apiServices/LeadershipPositionsServices";
import { encryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import SwalServices from "../../../services/swalServices/SwalServices";
import TextInput from "../../../components/UIComponent/TextInput";
import { getAuditContext } from "../../../utils/AuthenticationLibrary";

export default class ManageSecretariatDetails extends Component {
    constructor(props) {
        super(props);
        this.LeadershipPositionsServices = new LeadershipPositionsServices();
        this.swalServices = new SwalServices();
        this.onPageChange = null;
        this.state = {
            route: "",
            isLoading: false,
            totalResultes: 0,
            SecretariatDetails: [],
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                searchText: "",
            },
            secretariatDetails: {
                secretariatDetailsId: 0,
                name: "",
                designation: "",
                description: "",
                positionId: 0,
                linkedin: "",
                updatedBy: 0,
                updatedAppId: 0,
            },
            addEditDropdown: false,
            positionId: 0,
            dropdownId: 0,
            length: 0,
        };
    }
    componentDidMount() {
        if (!this.onPageChange)
            this.onPageChange = this.getAllSecretariatDetailsList;
        this.getAllSecretariatDetailsList();
    }
    setPagination = (newPagination) => {

        this.setState({ pagination: newPagination });
        if (this.onPageChange) {
            this.onPageChange();
        }
        this.getAllSecretariatDetailsList();
    }
    actions = (element, index, value) => {
        return (element !== "SecretariatDetailsId") ? null
            : (
                <td>
                    <ActionContainer>

                        <ActionEditButton
                            value={value}
                            id={index}
                            index={index}
                            onActionClick={this.onEdit}
                            text="Edit"
                        />
                        <ActionDeleteButton
                            value={value}
                            id={index}
                            index={index}
                            onActionClick={this.onDelete}
                            text="Delete"
                        />
                    </ActionContainer>
                </td>
            )
    }
    onEdit = (id) => {
        this.setState({ route: '/AddEditSecretariatDetails/SecretariatDetailsId?=' + encryptAES(id) });
    }
    onDelete = (SecretariatDetailsId) => {
        const Audit = getAuditContext()
        let request = {
            id: SecretariatDetailsId,
            deletedBy: Audit.adminUserId,
            appId: Audit.appId
        }

        this.LeadershipPositionsServices.deleteSecretariatDetails(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({ status: response.responseItem.responseContent });
                this.swalServices.Success("Deleted");
                this.getAllSecretariatDetailsList();
            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        })
    }
    getAllSecretariatDetailsList = (pagination = this.state.pagination) => {

        this.setState({ isLoading: true });
        this.LeadershipPositionsServices.getAllSecretariatDetailsList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                const SecretariatDetails = response.responseItem.responseContent.itemList.map(item => {
                    return {
                        ...item,
                        description: this.decodeHTMLEntities(item.description.replace(/<[^>]*>/g, ''))
                    };
                });
                this.setState({ SecretariatDetails: SecretariatDetails, totalResultes: response.responseItem.responseContent.totalCount, length: response.responseItem.responseContent.totalCount + 1 });
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        })
    }

    decodeHTMLEntities = (text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        return doc.documentElement.textContent;
    }
    resetSecretariatDetailData() {
        let details = { ...this.state.secretariatDetails };
        details.secretariatDetailsId = 0;
        details.name = "";
        details.designation = "";
        details.description = "";
        details.positionId = 0;
        details.linkedin = "";
        this.setState({ secretariatDetails: details });
    }
    getSecretariatTableData = (Id) => {
        this.resetSecretariatDetailData();
        this.setState({ addEditDropdown: true });
        this.LeadershipPositionsServices.getSecretariatDetailsById(Id)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    let detail = { ...this.state.secretariatDetails };
                    detail.secretariatDetailsId =
                        response.responseItem.responseContent.secretariatDetailsId;
                    detail.name =
                        response.responseItem.responseContent.name;
                    detail.designation = response.responseItem.responseContent.designation;
                    detail.description =
                        response.responseItem.responseContent.description;
                    detail.positionId = response.responseItem.responseContent.positionId;
                    detail.linkedin =
                        response.responseItem.responseContent.linkedin;
                    this.setState({ secretariatDetails: detail });
                } else {
                    this.swalServices.Error(response.message);
                }
            });
    };

    handleChangeForPositionId(event) {
        const value = event.target.value;
        const inputName = event.target.name;
        let detail = { ...this.state.secretariatDetails };
        if (inputName === "positionId") {
            let chcklength = this.state.length - 1;
            if (value > chcklength) {
                detail[inputName] = parseInt(chcklength);
            } else {
                detail[inputName] = parseInt(value);
            }
        } else {
            detail[inputName] = value;
        }
        this.setState({ secretariatDetails: detail });
    }

    updateSecretariatDetails = (secretariatDetailsId) => {
        this.setState({ addEditDropdown: false });
        let request = { ...this.state.secretariatDetails };

        request.secretariatDetailsId = secretariatDetailsId;
        request.name = this.state.secretariatDetails.name;
        request.designation = this.state.secretariatDetails.designation;
        request.description = this.state.secretariatDetails.description;
        request.positionId = this.state.secretariatDetails.positionId;
        request.linkedin = this.state.secretariatDetails.linkedin;
        request.updatedBy = this.state.secretariatDetails.updatedBy;
        request.updatedAppId = this.state.secretariatDetails.updatedAppId;

        this.LeadershipPositionsServices.updateSecretariatDetails(request)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.swalServices.Success("Ordering Position Updated Successfully!");
                    this.getAllSecretariatDetailsList();
                    this.setState({ addEditDropdown: false });
                } else {
                    this.swalServices.Error(response.message);
                }

            });
    };
    cancelAddEditDropdown() {
        this.setState({ addEditDropdown: false }, () => {
            this.resetSecretariatDetailData();
        });
    }

    render() {
        if (this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className="main-body-section">
                <div className="flex">
                    <div className="relative flex flex-col flex-1">
                        <main className="pb-10">
                            <div className="w-full mx-auto">
                                <div className="sm:flex sm:justify-between sm:items-center mb-8">
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="table-title-txt theme-color font-bold">
                                            {this.state.totalResultes} Secretariat Member
                                        </h1>
                                    </div>
                                    <CreateButton
                                        redirect="/AddEditSecretariatDetails"
                                        text="Create New"
                                    />
                                </div>
                                <div className="relative">
                                    <Table
                                        columns={[
                                            { name: "name", title: "Name" },
                                            { name: "designation", title: "Designation" },
                                            { name: "description", title: "Description" },
                                            { name: "positionId", title: "Arrangement Position" },
                                            {
                                                name: "SecretariatDetailsId",
                                                title: "Action",
                                            },
                                        ]}
                                        rows={this.state.SecretariatDetails}
                                        isLoading={this.state.isLoading}
                                        pagination={this.state.pagination}
                                        sortingColumns={[]}
                                        totalResultes={this.state.totalResultes}
                                        totalCount={this.state.totalResultes}
                                        setPagination={this.setPagination.bind(this)}
                                        customScope={[
                                            {
                                                column: 'SecretariatDetailsId',
                                                renderTableData: this.actions.bind(this)
                                            },
                                        ]}
                                    />


                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        );
    }
}
